import { deleteCookie, getCookie } from 'cookies-next'
import { getTenantLocaleKey } from '@/i18n/localeCookies'

const COOKIE_PATH = { path: '/' as const }

const SESSION_SCOPED_COOKIES = [
  'menu_id',
  'default_menu_id',
  'delivery_type',
  'source_id',
  'platform_id',
  'branch_id',
  'branch_slug',
  'is_hall',
] as const

function readCookieString(name: string): string | null {
  const value = getCookie(name)
  return typeof value === 'string' ? value : null
}

/** Remove menu/platform cookies and previous shipper tenant locale markers. */
export function clearShipperSessionCookies(previousShipperId?: string | null) {
  SESSION_SCOPED_COOKIES.forEach((name) => deleteCookie(name, COOKIE_PATH))

  if (previousShipperId) {
    const tenantKey = getTenantLocaleKey(previousShipperId)
    deleteCookie(`default_locale_${tenantKey}`, COOKIE_PATH)
    deleteCookie(`locale_redirect_done_${tenantKey}`, COOKIE_PATH)
  }
}

/** True once tenant locale cookies exist — safe to call router.refresh(). */
export function isTenantLocaleSettled(shipperId?: string | null): boolean {
  if (!shipperId) return false

  const tenantKey = getTenantLocaleKey(shipperId)
  return Boolean(
    readCookieString(`locale_redirect_done_${tenantKey}`) ||
      readCookieString(`default_locale_${tenantKey}`)
  )
}
